export default __webpack_public_path__ + "static/media/white_right-arrow_icon.f420958b.svg";